// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/all-images/find-car.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.find__cars-left {
    background: linear-gradient(rgb(221, 221, 221, 0.7), rgba(221, 221, 221, 0.7)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 65px 35px;
}
.find__cars-left h2 {
    font-weight: 600;
    font-size: 2.8rem;
    text-align: center;
}
.form__group {
    width: 30%;
    margin-bottom: 0;
}
.form__group::placeholder {
    color: #7c8a97;
}
.form__group label {
    margin-bottom: 10px;
    font-weight: 600;
    padding-left: 5px;
}
.form__group input, .form__group select {
    border: 1px solid #7c8a972a;
    padding: 8px 12px;
    outline: none;
    width: 100%
}
.form {
    background: #fff;
    padding-top: 55px;
    padding-bottom: 50px;
    padding-left: 15px;
    padding-right: 15px;
}
.select__group {
    width: 30%;
}
.select__group select {
    width: 100%;
    padding: 8px 15px;
    border: 1px solid #7c8a972a;
    outline: none;
    color: #7c8a972a;
}
.hero__slider-section {
    position: relative;
    z-index: 10;
    margin-bottom: 10px;
}
.hero__form {
    position: absolute;
    bottom: -80px;
    z-index: 11;
    width: 100%;
}
.form__row {
    background: #fff;
    box-shadow: 5px 5px 15px -5px #7c8a972a;
}
.journey__time::before {
    content: 'Journey time';
    margin-right: 0.8rem;
    color: #7c8a97;
}
.find__car-btn {
    background: #FF7F50;
    color: #fff;
    padding: 8px 15px;
    width: 100%;
    border: none;
    outline: none;
}
.css-13cymwt-control:hover {
    border:1px solid #7c8a972a!important;
    color: #000!important;
}
.css-t3ipsp-control:hover, .css-t3ipsp-control:active, .css-t3ipsp-control:visited {
    border:1px solid #7c8a972a!important;
    color: #000!important;
}
.css-t3ipsp-control{
    box-shadow: none!important;
    border:1px solid #7c8a972a!important;
    color: #000!important;
}
.css-1jqq78o-placeholder {
    color: initial!important;
}
@media only screen and (max-width:992px) {
    .find__cars-left {
        padding: 65px 22px;
    }
    .find__cars-left h2 {
        font-size: 1.5rem;
    }
    .form {
        padding: 30px 10px;
    }
    .form__group input, .select__group select {
        padding: 7px 10px;
        font-size: 0.8rem;
    }
    .hero__form {
        bottom: -100px;
    }
}
@media only screen and (max-width:768px) {
    .find__cars-left {
        padding-top: 20px;
        padding-bottom: 0;
        background: #fff;
        text-align: center;
    }
    .form {
        padding: 20px 10px;
    }
}
@media only screen and (max-width:576px) {
    .form__group {
        width: 100%;
        margin: auto;
        margin-bottom: 15px;
    }
    .form__group input {
        font-size: 0.7rem!important;
    }
    .select__group {
        width: 100%;
        padding-right: 10px;
        font-size: 0.7rem;
    }
    .find__car-btn {
        font-size: 0.8rem;
    }
    .find__cars-left h2 {
        font-size: 1rem;
    }
    .hero__form {
        bottom: -250px;
        
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/find-car-form.css"],"names":[],"mappings":"AAAA;IACI,uHAAwH;IACxH,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb;AACJ;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;AACA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;AACA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,oCAAoC;IACpC,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;;IAElB;AACJ","sourcesContent":[".find__cars-left {\n    background: linear-gradient(rgb(221, 221, 221, 0.7), rgba(221, 221, 221, 0.7)), url('../assets/all-images/find-car.jpg');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding: 65px 35px;\n}\n.find__cars-left h2 {\n    font-weight: 600;\n    font-size: 2.8rem;\n    text-align: center;\n}\n.form__group {\n    width: 30%;\n    margin-bottom: 0;\n}\n.form__group::placeholder {\n    color: #7c8a97;\n}\n.form__group label {\n    margin-bottom: 10px;\n    font-weight: 600;\n    padding-left: 5px;\n}\n.form__group input, .form__group select {\n    border: 1px solid #7c8a972a;\n    padding: 8px 12px;\n    outline: none;\n    width: 100%\n}\n.form {\n    background: #fff;\n    padding-top: 55px;\n    padding-bottom: 50px;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n.select__group {\n    width: 30%;\n}\n.select__group select {\n    width: 100%;\n    padding: 8px 15px;\n    border: 1px solid #7c8a972a;\n    outline: none;\n    color: #7c8a972a;\n}\n.hero__slider-section {\n    position: relative;\n    z-index: 10;\n    margin-bottom: 10px;\n}\n.hero__form {\n    position: absolute;\n    bottom: -80px;\n    z-index: 11;\n    width: 100%;\n}\n.form__row {\n    background: #fff;\n    box-shadow: 5px 5px 15px -5px #7c8a972a;\n}\n.journey__time::before {\n    content: 'Journey time';\n    margin-right: 0.8rem;\n    color: #7c8a97;\n}\n.find__car-btn {\n    background: #FF7F50;\n    color: #fff;\n    padding: 8px 15px;\n    width: 100%;\n    border: none;\n    outline: none;\n}\n.css-13cymwt-control:hover {\n    border:1px solid #7c8a972a!important;\n    color: #000!important;\n}\n.css-t3ipsp-control:hover, .css-t3ipsp-control:active, .css-t3ipsp-control:visited {\n    border:1px solid #7c8a972a!important;\n    color: #000!important;\n}\n.css-t3ipsp-control{\n    box-shadow: none!important;\n    border:1px solid #7c8a972a!important;\n    color: #000!important;\n}\n.css-1jqq78o-placeholder {\n    color: initial!important;\n}\n@media only screen and (max-width:992px) {\n    .find__cars-left {\n        padding: 65px 22px;\n    }\n    .find__cars-left h2 {\n        font-size: 1.5rem;\n    }\n    .form {\n        padding: 30px 10px;\n    }\n    .form__group input, .select__group select {\n        padding: 7px 10px;\n        font-size: 0.8rem;\n    }\n    .hero__form {\n        bottom: -100px;\n    }\n}\n@media only screen and (max-width:768px) {\n    .find__cars-left {\n        padding-top: 20px;\n        padding-bottom: 0;\n        background: #fff;\n        text-align: center;\n    }\n    .form {\n        padding: 20px 10px;\n    }\n}\n@media only screen and (max-width:576px) {\n    .form__group {\n        width: 100%;\n        margin: auto;\n        margin-bottom: 15px;\n    }\n    .form__group input {\n        font-size: 0.7rem!important;\n    }\n    .select__group {\n        width: 100%;\n        padding-right: 10px;\n        font-size: 0.7rem;\n    }\n    .find__car-btn {\n        font-size: 0.8rem;\n    }\n    .find__cars-left h2 {\n        font-size: 1rem;\n    }\n    .hero__form {\n        bottom: -250px;\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
